import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import { Component } from 'react';
import type { GenericDetailedError } from '~/errors/GenericDetailedError';

type DetailedErrorDialogProps = {};

interface DetailedErrorDialogState {
  open: boolean;
  message: string;
  details: string;
}

export class DetailedErrorDialog extends Component<DetailedErrorDialogProps, DetailedErrorDialogState> {
  constructor(props: DetailedErrorDialogProps) {
    super(props);
    this.state = {
      open: false,
      message: '',
      details: '',
    };
  }

  openDialog = (error: GenericDetailedError) => {
    this.setState({
      open: true,
      message: error.message,
      details: error.details,
    });
  };

  closeDialog = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    // const { classes } = this.props;
    return (
      <Dialog open={this.state.open} onClose={this.closeDialog} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Ett fel inträffade</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DialogContentText>{this.state.message}</DialogContentText>
            </Grid>
            <Grid item xs={12}>
              <DialogContentText>Detaljer: {this.state.details}</DialogContentText>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeDialog} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
